
  import { defineComponent } from 'vue';
  import outerClick from '@mdp/mdp-ui-kit/src/directives/outerClick/outerClick';

  export default defineComponent({
    name: 'LanguageSelect',
    directives: {
      outerClick,
    },
    props: {},
    data() {
      return {
        isOpen: false,
      };
    },
    methods: {
      toggleOpen() {
        this.isOpen = !this.isOpen;
      },
      close() {
        this.isOpen = false;
      },
    },
  });
